import {
  notEmptyString,
} from '@populateui/utils';
import {
  EOBServiceLineRetirementReason,
} from 'dtos/eOBServiceLineRetirementReason';
import {
  ServiceAllocation,
} from 'pages/Dashboard/pages/Billing/types';

type StatusDisplay = { label: string; tooltip: string };

export const serviceLineStatusByReason: Record<
  EOBServiceLineRetirementReason,
  StatusDisplay
> = {
  [EOBServiceLineRetirementReason.SupersededByCorrection]: {
    label: 'Superseded',
    tooltip: 'Superseded by correction',
  },
  [EOBServiceLineRetirementReason.SupersededByLaterPosting]: {
    label: 'Superseded',
    tooltip: 'Superseded by later posting',
  },
  [EOBServiceLineRetirementReason.Reversed]: {
    label: 'Reversed',
    tooltip: 'Reversed',
  },
  [EOBServiceLineRetirementReason.Reversal]: {
    label: 'Reversal',
    tooltip: 'Reversal',
  },
};

const excludedStatusDisplay: StatusDisplay = {
  label: 'Excluded',
  tooltip: 'Excluded from the payment calculation',
};

export function isServiceLineInactive(
  row?: ServiceAllocation | null,
): boolean {
  return row?.isExcluded || notEmptyString(row?.retirementReason);
}

export function getServiceLineStatusDisplay(
  row?: ServiceAllocation | null,
): StatusDisplay | null {
  const { retirementReason } = row ?? {};
  const retirementDisplay = notEmptyString(retirementReason)
    ? (serviceLineStatusByReason[
      retirementReason as EOBServiceLineRetirementReason
    ] ?? null)
    : null;
  const excludedDisplay = row?.isExcluded ? excludedStatusDisplay : null;

  return retirementDisplay ?? excludedDisplay;
}
